import type { Alert } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetAlerts } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useAlertsSWRKey } from "./useAlertsSWRKey"

export function useAlerts(): SWRResponse<Array<Alert>> {
  const alertsSWRKey = useAlertsSWRKey()
  const getAlerts = useGetAlerts()

  const getAlertsData = useMemo(
    () => !getAlerts ? null : (async () => {
      const response = await getAlerts({ params: {} })
      return response
    }),
    [getAlerts],
  )

  return useSWR<Array<Alert>>(
    alertsSWRKey,
    getAlertsData,
  )
}
